export const LANDING = {
    // Navigation
    nav: 'landing-nav',
    navLogo: 'nav-logo',
    navLinkFeatures: 'nav-link-features',
    navLinkHowItWorks: 'nav-link-how-it-works',
    navLinkTestimonials: 'nav-link-testimonials',
    navDownloadBtn: 'nav-download-btn',
    navMobileToggle: 'nav-mobile-toggle',

    // Hero
    heroSection: 'hero-section',
    heroTitle: 'hero-title',
    heroTagline: 'hero-tagline',
    heroSubline: 'hero-subline',
    heroCtaPrimary: 'hero-cta-primary',
    heroCtaSecondary: 'hero-cta-secondary',
    heroMockup: 'hero-mockup',

    // Stats Bar
    statsBar: 'stats-bar',
    statExercises: 'stat-exercises',
    statMeasurements: 'stat-measurements',
    statSections: 'stat-sections',

    // Features
    featuresSection: 'features-section',
    feature: (i) => `feature-${i}`,

    // How It Works
    howItWorksSection: 'how-it-works-section',
    step: (i) => `how-step-${i}`,

    // Testimonials
    testimonialsSection: 'testimonials-section',
    testimonial: (i) => `testimonial-${i}`,

    // Final CTA
    finalCtaSection: 'final-cta-section',
    finalCtaBtn: 'final-cta-btn',

    // Footer
    footer: 'landing-footer',
    footerLinkPrivacy: 'footer-link-privacy',
    footerLinkTerms: 'footer-link-terms',
    footerLinkContact: 'footer-link-contact',
};
